<template>
  <div style="width: 100%">
    <el-row class="search-group" v-for="(group, x) in vnodeGroup" :key="x">
      <el-col :span="calcSpan" v-for="(vnode, y) in group" :key="y">
        <eco-vnode
          :vnode="vnode"
          :label-width="labelWidth"
          @enter-search="search(fieldArray)"
          @field-loaded="handleFieldLoaded"
          @input-change="handleInputChange"
        />
      </el-col>
    </el-row>
    <el-row class="search-group">
      <div :style="{ marginLeft: labelWidth + 'px' }">
        <el-button type="primary" size="small" @click="search(fieldArray)"
          >搜索</el-button
        >
        <el-button size="small" @click="reset">重置</el-button>
        <el-button size="small" @click="closePop">关闭</el-button>
      </div>
    </el-row>
  </div>
</template>
<script>
export default {
  name: "eco-table-search-panel",
  props: {
    divide: {
      type: Number,
      default: 4,
      validator: value => {
        return value > 0 && value < 5;
      }
    },
    labelWidth: {
      type: Number,
      default: 70
    }
  },
  data() {
    return {
      fieldVms: [],
      fieldArray: [],
      vnodeGroup: []
    };
  },
  computed: {
    calcSpan: {
      get() {
        return 24 / this.divide;
      }
    }
  },
  created() {
    const me = this;
    this.$slots.default.forEach((v, index) => {
      const groupId = Math.ceil((index + 1) / this.divide);
      let group = this.vnodeGroup[groupId - 1];
      if (!group) {
        group = [];
        this.vnodeGroup[groupId - 1] = group;
      }
      this.fieldArray.push({ ...v.componentOptions.propsData });
      group.push(v);
    });
    let this_ = this;
    // document.onkeydown = function(e) {
    //     let key = window.event.keyCode;
    //     if (key != 13) {
    //         return;
    //     }
    //     this_.search();
    // };
  },
  methods: {
    handleInputChange(obj, prop) {
      this.fieldArray = this.fieldArray.map((field, index) => {
        return field.prop == prop ? { ...field, ...obj } : field;
      });
    },
    handleFieldLoaded(ref) {
      // 搜索条件挂载完成后，添加其实例到数组中
      this.fieldVms.push(ref);
    },
    closePop() {
      this.$parent.$emit("pophide", this.fieldArray);
      this.reset();
    },
    search(data, reset) {
      this.$parent.$emit("advancesearch", data, reset);
    },
    reset() {
      this.fieldVms.forEach(vm => {
        vm.data = null;
      });
      this.$nextTick(() => {
        this.search(this.fieldArray, "reset");
      });
    }
  }
};
</script>
<style lang="stylus" scoped>
.search-group {
  margin-bottom: 15px;
}
</style>
